import { z } from 'zod';
import { INBOX_STATES, type InboxFilters } from '@/api/inbox';

/** Parámetros de URL de la bandeja (los comparte el panel y el portal): estado, canal, solo no leídas y la conversación abierta. Nunca texto de mensajes. */
export const inboxSearchFields = {
  /** Estado de la lista (por omisión `handoff`; solo se escribe si es otro). */
  state: z.enum(INBOX_STATES).optional().catch(undefined),
  unread: z.boolean().optional().catch(undefined),
};

export const inboxSearchSchema = z.object({
  tenant: z.string().optional(),
  channel: z.enum(['widget', 'whatsapp', 'instagram']).optional().catch(undefined),
  conversation: z.string().optional(),
  ...inboxSearchFields,
});
export type InboxSearch = z.infer<typeof inboxSearchSchema>;

const CHANNELS = ['widget', 'whatsapp', 'instagram'] as const;

/** Filtros efectivos para la API (el canal del portal puede traer valores de prueba: se ignoran). */
export function toInboxFilters(s: {
  state?: InboxFilters['state'] | undefined;
  channel?: string | undefined;
  unread?: boolean | undefined;
}): InboxFilters {
  const channel = CHANNELS.find((c) => c === s.channel);
  return { state: s.state ?? 'handoff', ...(channel ? { channel } : {}), ...(s.unread ? { unread: true } : {}) };
}
